module.exports = {"310101002":"南京东路街道","310101013":"外滩街道","310101015":"半淞园路街道","310101017":"小东门街道","310101018":"豫园街道","310101019":"老西门街道","310101020":"五里桥街道","310101021":"打浦桥街道","310101022":"淮海中路街道","310101023":"瑞金二路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310101.json
// module id = 907
// module chunks = 0